// A loading-failed message with a Retry button, the same look wherever finance data fails to load.
import { Button } from "@/components/ui/Button";
import { Callout } from "@/components/ui/Callout";

export function RetryBlock({ message, retrying, onRetry }: { message: string; retrying: boolean; onRetry: () => void }) {
  return (
    <Callout tone="red" className="flex items-center gap-3">
      <span>{message}</span>
      <Button size="sm" variant="secondary" onClick={onRetry} isLoading={retrying}>Retry</Button>
    </Callout>
  );
}
